import axios from 'axios';
import { FETCH_VENDORS_SUCCESS, FETCHING_VENDORS } from './VendorsConstants';

const path = 'utm/v1/transactions/vendor-information';

const fetchingVendors = () => ({ type: FETCHING_VENDORS });
const fetchVendorsSuccess = vendors => ({ type: FETCH_VENDORS_SUCCESS, vendors });

export const fetchVendors = () => dispatch => {
  dispatch(fetchingVendors());
  axios.get(path)
    .then(vendorsResponse => {
      dispatch(fetchVendorsSuccess(vendorsResponse.data.data));
    })
    .catch(error => {
      throw error;
    });
};



// WEBPACK FOOTER //
// ./src/redux/vendors/VendorsActions.js